import { FC, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { Header } from "../header";
import { Footer } from "../footer";
import { Root, StyledContainer } from "./styled";

export const Layout: FC = () => {
  const location = useLocation();

  useEffect(() => {
    const timerId = setTimeout(() => {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    });
    return () => {
      clearTimeout(timerId);
    };
  }, [location.pathname]);

  return (
    <>
      <Root>
        <Header />
        <StyledContainer maxWidth="xl">
          <Outlet />
        </StyledContainer>
      </Root>
      <Footer />
    </>
  );
};
